class Tabs {
  constructor() {
    this.tabs = document.querySelectorAll('.js-tabs li');
    this.contents = document.querySelectorAll('.js-tab-content');
  }
  init() {
    if (this.tabs.length > 0) {
      this.bindEvents();
      this.tabsByHashPathActivation();
    }
  }
  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.currentTarget.classList.add('is-active');
        const targetId = e.currentTarget.dataset.target;
        this.tabs.forEach((tab) => {
          if (tab !== e.currentTarget) {
            tab.classList.remove('is-active');
          }
        });
        this.contents.forEach((content) => {
          if (content.id == targetId) {
            content.classList.add('is-active');
          } else {
            content.classList.remove('is-active');
          }
        });
      });
    });
  }

  /**
   * This method will click on the content tab in dependency which hash string comes in url
   */
  tabsByHashPathActivation() {
    const tabHash = window.location.hash.slice(1);

    if (tabHash.length > 0) {
      const tabElm = document.querySelector('[data-target="' + tabHash + '"]');

      if (tabElm) {
        tabElm.click();
      }
    }
  }
}

export default new Tabs();
